module.exports = __webpack_public_path__ + "static/media/video_verfication_audio.35b714b7.mp3";